module.exports = __webpack_public_path__ + "img/small.dac6d4ec.jpg";